import React from 'react'
import Newsletter from '../Form/Newsletter'

const Footer = () => {
  return (
    <footer className='bg-secundaria py-24'>
      <div className='mx-auto max-w-screen-lg'>
        <section className='flex flex-col sm:flex-row justify-around items-start font-basis text-center text-azul font-bold'>
          <div className='block mx-auto mb-24 sm:mb-0'>
            <h4 className='text-2xl mb-4'>Custom Packaging</h4>
            <a href='/' className='block text-lg'>Mailer Boxes</a>
            <a href='/' className='block text-lg'>Product Boxes</a>
            <a href='/' className='block text-lg'>Standard Shipping Boxes</a>
            <a href='/' className='block text-lg'>Econoflex Shipping Boxes</a>
          </div>
          <div className='block mx-auto mb-24 sm:mb-0'>
            <h4 className='text-2xl mb-4'>Company</h4>
            <a href='/' className='block text-lg'>About Us</a>
            <a href='/' className='block text-lg'>Terms & Conditions</a>
            <a href='/' className='block text-lg'>Privacy Policy</a>
            <a href='/' className='block text-lg'>Jobs</a>
            <a href='/' className='block text-lg'>Blog</a>
          </div>
          <div className='block mx-auto mb-24 sm:mb-0'>
            <h4 className='text-2xl mb-4'>Help</h4>
            <a href='/' className='block text-lg'>Support Portal</a>
            <a href='/' className='block text-lg'>Artwork Tips and Tricks</a>
            <a href='/' className='block text-lg'>Find a Designer</a>
            <a href='/' className='block text-lg'>Request a Quote</a>
            <a href='/' className='block text-lg'>FAQs</a>
          </div>
        </section>
        <Newsletter />
        <section className='flex mt-24 flex-col justify-around items-center font-basis text-center text-azul font-bold'>
          <div className='mx-12 sm:mx-32'>
            <h4 className='text-2xl mb-4'>Payment Methods</h4>
            <p className='block text-lg max-w-500'>Our website is compatible with many popular payment methods. SSL 100% Secure Transactions.</p>
          </div>
          <div className="flex w-1/5 mt-12 min-w-300">
            <picture className='flex-1 mx-2'>
              <img alt="Mastercard" className='w-full' src="https://assets.packlane.com/images/mastercard.svg" />
            </picture>
            <picture className='flex-1 mx-2'>
              <img alt="Visa" className='w-full' src="https://assets.packlane.com/images/visa.svg" />
            </picture>
            <picture className='flex-1 mx-2'>
              <img alt="American Express" className='w-full' src="https://assets.packlane.com/images/cc/amex-logo.svg" />
            </picture>
            <picture className='flex-1 mx-2'>
              <img alt="JCB" className='w-full' src="https://assets.packlane.com/rZfwBfu-uUxxPSt9rUEBkMLhODW-jwfWrzAa7ceGXYg/fn:jcb-logo/czM6Ly9wYWNrbGFuZS1hc3NldHMvcHJvZHVjdGlvbi9hcHAvaW1hZ2VzL2NjL2pjYi1sb2dvLnBuZw.jpg" />
            </picture>
            <picture className='flex-1 mx-2'>
              <img alt="Discover" className='w-full' src="https://assets.packlane.com/images/cc/discover-logo.svg" />
            </picture>
          </div>
        </section>
        <section className='mx-auto text-center my-12'>
          <picture className='block w-full mb-6'>
            <img alt="Packlane" className='mx-auto' src="https://assets.packlane.com/images/packlane-iso.svg" />
          </picture>
          <div className='text-xs text-azul font-basis font-bold'>
            <p>Copyright © 2021 Packlane, Inc. All rights reserved.</p>
            <p>Packlane™ is a trademark of Packlane, Inc. in the United States and other countries.</p>
            <br />
            <p>3865 Produce Road #207, Louisville, KY 40218 • 855-289-7687</p>
          </div>

        </section>
      </div>
    </footer>
  )
}

export default Footer
